/* i18n layer. The portal runs in English; owner-facing documents render in the tenant's owner language
   (`org.language`, resolved server-side from the explicit setting or the country). Every user-facing string
   goes through t() / tx(). Missing keys fall back to English, never to a raw key when English has it. */
import { en } from "@/lib/locales/en";
import { nb } from "@/lib/locales/nb";

const DICTS = { en, nb };
export const LOCALES = Object.keys(DICTS);
let current = "en";

export const setLocale = (l) => {
  if (DICTS[l]) current = l;
};
export const getLocale = () => current;

/** BCP-47 tag for Intl formatting of a document locale. */
export const localeTag = (l) => ({ nb: "nb-NO", en: "en-GB" }[l] || "en-GB");

const COUNTRY_LANGUAGE = { NO: "nb" };
/** Language of owner-facing documents for an organisation (mirrors the backend rule: explicit setting, else country). */
export function ownerLanguage(org) {
  if (!org) return "en";
  if (org.language && DICTS[org.language]) return org.language;
  const pref = String(org.owner_language || "auto").toLowerCase();
  if (DICTS[pref]) return pref;
  return COUNTRY_LANGUAGE[String(org.country || "").toUpperCase()] || "en";
}

/** Translate in an explicit locale (owner documents inside the English portal). */
export function tx(locale, key, vars) {
  const dict = DICTS[locale] || en;
  let s = dict[key] ?? en[key] ?? key;
  if (vars) {
    Object.entries(vars).forEach(([k, v]) => {
      s = s.replace(new RegExp(`\\{${k}\\}`, "g"), String(v));
    });
  }
  return s;
}

export function t(key, vars) {
  return tx(current, key, vars);
}

export default t;
